var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeSimpleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.75C9.538 21.75 8.25 16.845 8.25 12C8.25 7.155 9.538 2.25 12 2.25C14.462 2.25 15.75 7.155 15.75 12C15.75 16.845 14.462 21.75 12 21.75ZM12 3.75C11.236 3.75 9.75 6.662 9.75 12C9.75 17.338 11.236 20.25 12 20.25C12.764 20.25 14.25 17.338 14.25 12C14.25 6.662 12.764 3.75 12 3.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 2.25C6.624 2.25 2.25 6.624 2.25 12C2.25 17.376 6.624 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.624 17.376 2.25 12 2.25ZM3.75 12C3.75 11.219 3.866 10.466 4.07 9.75H19.93C20.134 10.466 20.25 11.219 20.25 12C20.25 12.781 20.134 13.534 19.93 14.25H4.07C3.866 13.534 3.75 12.781 3.75 12ZM12 3.75C15.198 3.75 17.971 5.583 19.339 8.25H4.661C6.03 5.583 8.802 3.75 12 3.75ZM12 20.25C8.802 20.25 6.029 18.417 4.661 15.75H19.339C17.97 18.417 15.198 20.25 12 20.25Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeSimpleWhite);
export default __webpack_public_path__ + "static/media/GlobeSimpleWhite.abaa665b0fab2b052ce8008d3cc1c935.svg";
export { ForwardRef as ReactComponent };